import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs/Subscription';
import { FontAwesomeService } from '@services/font-awesome.service';
import { VersionCheckService } from '@services/version-check.service';
import { GoogleAnalyticsEventsService } from '@services/google-analytics-events.service';
import { User } from './model/user.interface';
import { Store } from '@ngrx/store';
import { ModalState, selectModal } from '@store/reducers/modal.reducer';
import { DialogSharedComponent } from '@components/dialog-shared/dialog-shared.component';
import { MatDialog } from '@angular/material';
import { AppState, selectUser } from '@store/reducers';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import { Subject } from 'rxjs/Subject';
import { SearchService } from '@services/search.service';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { environment } from '../environments/environment';
import { ngxZendeskWebwidgetService } from 'ngx-zendesk-webwidget';
import 'rxjs/add/operator/map';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
  opened = false;
  getLang = 'en';
  isLoggedIn: Boolean;
  userSubscription: Subscription;
  searchSubscription: Subscription;
  user: User;
  public infoAlertOpen = false;

  private searchText = new BehaviorSubject<string>('');

  constructor(
    private router: Router,
    private translate: TranslateService,
    public faService: FontAwesomeService,
    private store: Store<AppState>,
    public dialog: MatDialog,
    public googleAnalyticsEventsService: GoogleAnalyticsEventsService,
    private searchService: SearchService,
    public versionCheckService: VersionCheckService,
    private zendesk: ngxZendeskWebwidgetService
  ) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.googleAnalyticsEventsService.pageview(event.urlAfterRedirects);
      }
    });

    this.zendesk.setSettings({
      webWidget: {
        position: {horizontal: 'left', vertical: 'bottom'},
        offset: {horizontal: '40px', vertical: '0'},
        color: {theme: '#30dc9f'}
        /*
        contactForm: {
          fields: [
            { id: 'description', prefill: { '*': this.translate.instant('support.cancelShipment') } }
          ],
          ticketForms: [
            {id: 360019804432}
          ]
        }
        */
      }
    });
    this.zendesk.show();

    // Set default language
    this.translate.addLangs(['en', 'sv']);
    if (!sessionStorage.getItem('lang')) {
      const browserLang: string = this.translate.getBrowserLang();
      this.getLang = this.translate.getLangs().indexOf(browserLang) > -1 ? browserLang : 'en';
      sessionStorage.setItem('lang', this.getLang);
    } else {
      this.getLang = sessionStorage.getItem('lang');
    }
    this.translate.setDefaultLang(this.getLang);
    this.translate.use(this.getLang);
    this.zendesk.setLocale(this.getLang);
  }

  ngOnInit() {
    // this.infoAlertOpen = true;
    this.store.select(selectUser)
      .subscribe((data: any) => {
        this.user = data;
        // sessionStorage.setItem('user', JSON.stringify(data));
        // console.log(JSON.parse(sessionStorage.getItem('user')));
        this.isLoggedIn = !!this.user;
        this.opened = !!this.user;
        if (this.user) {
          this.versionCheckService.initVersionCheck(environment.versionCheckURL);
          this.zendesk.identify({
            name: this.user.name + ' ' + this.user.surname,
            email: this.user.email
          });
        }
      });

    this.versionCheckService.hasVersionChanged.subscribe((value) => {
      this.infoAlertOpen = value;
      if (this.isLoggedIn) {
      }
    });

    this.searchText
      .debounceTime(500)
      .distinctUntilChanged()
      .filter((value) => !!value)
      .map((value) => value.toString().trim())
      .subscribe((key) => {
        this.router.navigate(['track', key]);
      });

    this.searchService.resetSearchField.subscribe(() => this.searchText.next(''));
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.store.select(selectModal)
        .subscribe((data: ModalState) => {
          if (data.showModal) {
            this.dialog.open(DialogSharedComponent, {width: '450px', data});
          }
        });
    }, 1);
  }

  ngOnDestroy() {
    this.userSubscription.unsubscribe();
    this.searchSubscription && this.searchSubscription.unsubscribe();
  }

  toggleLeftBar() {
    this.opened = !this.opened;
  }

  showApplicationUpdated() {

  }

  handleReload(event) {
    this.infoAlertOpen = false;
    location.reload(true);
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts